import React from 'react';

// Create a context with no initial values.
export const AvailabilityCalendarContext = React.createContext();

export default AvailabilityCalendarContext;
